import InstantSearch from './src/instantsearch.js';
export default InstantSearch;
export * from './src/instantsearch.js';